import { render, staticRenderFns } from "./ReportGroupMealsTakenCompanyMonthlyOrders.vue?vue&type=template&id=5c10a1e0"
import script from "./ReportGroupMealsTakenCompanyMonthlyOrders.vue?vue&type=script&lang=js"
export * from "./ReportGroupMealsTakenCompanyMonthlyOrders.vue?vue&type=script&lang=js"
import style0 from "./ReportGroupMealsTakenCompanyMonthlyOrders.vue?vue&type=style&index=0&id=5c10a1e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports